<template>
    <div class="page-container">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <span class="page-title">系统设置</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>提币充币提醒设置</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card class="page-content" shadow="never">
            <el-form :inline="true">
                <el-form-item>
                    <el-button type="primary" icon="el-icon-plus" @click="createShow = true">添加</el-button>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="queryCoinType" placeholder="请输出币种"/>
                </el-form-item>
                <el-form-item>
                    <el-button type="success" @click="queryInfo()">查询</el-button>
                </el-form-item>
            </el-form>

            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="充币提醒设置" name="rechargeRemind">
                    <el-table :data="coinRechargeList">
                        <el-table-column prop="coinType" label="币种"></el-table-column>
                        <el-table-column prop="chainType" label="链类型"/>
                        <el-table-column prop="contentZh" label="中文内容"/>
                        <el-table-column prop="contentEn" label="英文内容"/>
                        <el-table-column prop="contentKr" label="韩文内容"/>
                        <el-table-column prop="contentVi" label="越南语内容"/>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-button type="primary" circle icon="el-icon-edit"
                                           @click="coinType = scope.row.coinType,optionType = '充币',
                                          contentZh = scope.row.contentZh,
                                          contentEn = scope.row.contentEn,
                                           contentKr = scope.row.contentKr,
                                           contentVi = scope.row.contentVi,
                                           chainType = scope.row.chainType,
                                            alterId = scope.row.id,
                                          alterShow = true"></el-button>
                                <el-button type="danger" circle icon="el-icon-delete"
                                           @click="deleteCoinRemind(scope.row,'recharge')"></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane label="提币提醒设置" name="extractRemind">
                    <el-table :data="coinExtractList">
                        <el-table-column prop="coinType" label="币种"></el-table-column>
                        <el-table-column prop="chainType" label="链类型"/>
                        <el-table-column prop="contentZh" label="中文内容"/>
                        <el-table-column prop="contentEn" label="英文内容"/>
                        <el-table-column prop="contentKr" label="韩文内容"/>
                        <el-table-column prop="contentVi" label="越南语内容"/>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-button type="primary" circle icon="el-icon-edit"
                                           @click="coinType = scope.row.coinType,optionType = '提币',
                                           contentZh = scope.row.contentZh,
                                           contentEn = scope.row.contentEn,
                                           contentKr = scope.row.contentKr,
                                             contentVi = scope.row.contentVi,
                                           chainType = scope.row.chainType,
                                           alterId = scope.row.id,
                                           alterShow = true"></el-button>
                                <el-button type="danger" circle icon="el-icon-delete"
                                           @click="deleteCoinRemind(scope.row,'extract')"></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
            <alter-remind :coinType='coinType' :id='alterId' :chainType='chainType' :optionType='optionType'
                          :alterShow='alterShow' :contentZh="contentZh" :contentEn="contentEn" :contentKr="contentKr"
                          :content-vi="contentVi"
                          @refresh="refreshList"></alter-remind>
        </el-card>
        <create-remind :createShow='createShow' @refresh="refreshList"></create-remind>
    </div>
</template>

<script>
    import './store';
    import {mapActions, mapState} from 'vuex';
    import CreateRemind from './components/create';
    import AlterRemind from './components/alter';

    export default {
        name: "coinRemindSetting",
        components: {CreateRemind, AlterRemind},
        data() {
            return {
                activeName: 'rechargeRemind',
                coinType: '',
                alterShow: false,
                createShow: false,
                optionType: '',
                contentZh: '',
                contentEn: '',
                contentKr: '',
                contentVi: '',
                chainType: '',
                alterId: '',
                queryCoinType: ''
            }
        },
        computed: {
            ...mapState("coinRemindSetting", ['coinRechargeList', 'coinExtractList']),
        },
        methods: {
            ...mapActions('coinRemindSetting', ['getCoinRechargeList', 'getCoinExtractList', 'removeCoinRemind']),
            deleteCoinRemind(info, optionType) {
                if (optionType === 'recharge') {
                    this.removeCoinRemind({
                        coinType: info.coinType,
                        optionType: 'recharge',
                        chainType: info.chainType
                    }).then(() => {
                        this.refreshList();
                        this.$message({type: 'success', message: '删除成功'})
                    })
                } else {
                    this.removeCoinRemind({
                        coinType: info.coinType,
                        optionType: 'extract',
                        chainType: info.chainType
                    }).then(() => {
                        this.refreshList();
                        this.$message({type: 'success', message: '删除成功'})
                    })
                }

            },
            refreshList() {
                this.alterShow = false;
                this.createShow = false;
                this.queryInfo();
            },
            queryInfo() {
                if (this.activeName === 'rechargeRemind') {
                    this.getCoinRechargeList({coinType: this.queryCoinType});
                }
                if (this.activeName === 'extractRemind') {
                    this.getCoinExtractList({coinType: this.queryCoinType})
                }
            },
            handleClick(tab, event) {
                this.queryInfo();
            }
        },
        created() {
            this.queryInfo();
        }
    }
</script>

<style scoped>

</style>
